/**
 * Generates a unique identifier.
 * @returns {string} The generated unique identifier.
 */
export function generateUID() {
  // Define the characters used for the identifier.
  const characters = '0123456789abcdef';

  // Define a function to get a random character from the characters string.
  const getRandomCharacter = () => characters[Math.floor(Math.random() * characters.length)];

  // Generate the parts of the unique identifier.
  const uidParts = [
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    '-',
    '4',
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    '-',
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    '-',
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter(),
    getRandomCharacter()
  ];

  // Join the uid parts together and return the generated unique identifier.
  return uidParts.join('');
}

/**
 * 节流函数，防止高频触发
 * @param fn 需要节流的函数
 * @param delay 节流间隔（毫秒）
 */
export function throttle<T extends unknown[]>(fn: (...args: T) => void, delay: number) {
  let last = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;
  return function (this: unknown, ...args: T) {
    const now = Date.now();
    if (now - last >= delay) {
      last = now;
      fn.apply(this, args);
    } else if (!timer) {
      timer = setTimeout(
        () => {
          last = Date.now();
          timer = null;
          fn.apply(this, args);
        },
        delay - (now - last)
      );
    }
  };
}
